export default {
	name: 'shellysmknb',
	friendly_name: 'Flood NB',
	family: 'sensor',
	isPM: false,
	is_nb: true,
	modes: ['sensor'],
	settings: [{ title: 'not_ready' }],
};
